/**
 * @deprecated This file is maintained for backward compatibility.
 * Please import from the new modular structure:
 * - Filename manipulation: import from './file/filename-manipulator'
 * - Extension utilities: import from './file/extension-utils'
 */

import { DropboxFile } from '../models/dropbox-file';
import { GoogleDriveFile } from '../models/google-drive-file';

// Re-export from new modules for backward compatibility
export {
    replaceExtension,
    getBasename,
    getFilenameFromPath,
    getFilename,
    getFileMimeType,
    getFileMimeTypeFromFilename,
    sanitizeFilename,
    truncateFilename,
} from './file/filename-manipulator';

export {
    getExtension,
} from './file/extension-utils';

/**
 * @deprecated Use imports from './file/filename-manipulator' instead.
 * This class is maintained for backward compatibility only.
 */
export class FilenameUtils {
    /** @deprecated Use replaceExtension from './file/filename-manipulator' */
    public static replaceExtension(fileName: string, extension: string) {
        const { replaceExtension } = require('./file/filename-manipulator');
        return replaceExtension(fileName, extension);
    }

    /** @deprecated Use getExtension from './file/extension-utils' */
    public static getExtension(fileName: string) {
        const { getExtension } = require('./file/extension-utils');
        return getExtension(fileName);
    }

    /** @deprecated Use getBasename from './file/filename-manipulator' */
    public static getBasename(filePath: string) {
        const { getBasename } = require('./file/filename-manipulator');
        return getBasename(filePath);
    }

    /** @deprecated Use getFilename from './file/filename-manipulator' */
    public static getFilename(filePath: string) {
        const { getFilename } = require('./file/filename-manipulator');
        return getFilename(filePath);
    }

    /** @deprecated Use getFileMimeType from './file/filename-manipulator' */
    public static getFileMimeType(file: File | GoogleDriveFile | DropboxFile) {
        const { getFileMimeType } = require('./file/filename-manipulator');
        return getFileMimeType(file);
    }

    /** @deprecated Use getFileMimeTypeFromFilename from './file/filename-manipulator' */
    public static getFileMimeTypeFromFilename(filename: string) {
        const { getFileMimeTypeFromFilename } = require('./file/filename-manipulator');
        return getFileMimeTypeFromFilename(filename);
    }
}

/**
 * Short, human tool name for user-facing messages.
 *
 * `pageData.title` is the SEO <title> — "GIF Compressor — Compress GIF Free, No Watermark
 * | XConvert" — and it was being dropped verbatim into the middle of the upload-rejection
 * sentence, which read like a machine fault. `breadcrumbText` is the label written for
 * humans ("Compress GIF", "Convert MP4 to GIF"), so prefer it, then the visible H1, and
 * only fall back to trimming the SEO title at its first separator.
 */
export function getToolDisplayName(
    pageData?: { breadcrumbText?: string; page_seo?: { title?: string }; title?: string },
    fallback = 'this tool',
): string {
    const breadcrumb = pageData?.breadcrumbText?.trim();
    if (breadcrumb && breadcrumb.toLowerCase() !== 'home') return breadcrumb;

    const h1 = pageData?.page_seo?.title?.trim();
    if (h1) return h1;

    const seoTitle = pageData?.title?.trim();
    if (seoTitle) {
        // Keep only the leading clause: everything before the first em/en dash or pipe.
        const trimmed = seoTitle.split(/\s[—–|]\s|\s\|\s?/)[0].trim();
        if (trimmed) return trimmed;
    }
    return fallback;
}
